import _classCallCheck from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Split } from '../split';
export var ProjectionComponent = /*#__PURE__*/function (_Split) {
  _inherits(ProjectionComponent, _Split);

  function ProjectionComponent(name, specifiedProjection, size, data) {
    var _this;

    _classCallCheck(this, ProjectionComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProjectionComponent).call(this, Object.assign({}, specifiedProjection), // all explicit properties of projection
    {
      name: name
    } // name as initial implicit property
    ));
    _this.specifiedProjection = specifiedProjection;
    _this.size = size;
    _this.data = data;
    _this.merged = false;
    return _this;
  }
  /**
   * Whether the projection parameters should fit provided data.
   */


  _createClass(ProjectionComponent, [{
    key: "isFit",
    get: function get() {
      return !!this.data;
    }
  }]);

  return ProjectionComponent;
}(Split);